import { toLocaleString } from "@circle-react/helpers/number";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type {
  ContentReactionCounts,
  ContentReactionType,
} from "@circle-react/types/ContentReaction";
import { CONTENT_REACTION_TYPES } from "@circle-react/types/ContentReaction";
import { sentimentIconName } from "@circleco/compass/components/Icon";
import { Tabs } from "@circleco/compass/components/Tabs";
import type { Tab } from "@circleco/compass/components/Tabs";

import { t } from "@/i18n-js/instance";

import { REACTION_PRESENTATION } from "./constants";

interface ReactionFilterTabsProps {
  className?: string;
  counts: ContentReactionCounts;
  onChange: (reactionType: ContentReactionType | null) => void;
  selectedReaction: ContentReactionType | null;
  totalCount: number;
}

export const ReactionFilterTabs = ({
  className,
  onChange,
  counts,
  selectedReaction,
  totalCount,
}: ReactionFilterTabsProps) => {
  const tabs: Tab[] = [
    {
      value: "all",
      label: `${t("reactions.all")} ${toLocaleString(totalCount)}`,
    },
    ...CONTENT_REACTION_TYPES.flatMap(reactionType => {
      const count = counts[reactionType];
      if (count <= 0) return [];

      return [
        {
          value: reactionType,
          label: toLocaleString(count),
          icon: sentimentIconName(
            REACTION_PRESENTATION[reactionType].sentiment,
          ),
        },
      ];
    }),
  ];

  const handleValueChange = (value: string) => {
    const reactionType = CONTENT_REACTION_TYPES.find(type => type === value);
    onChange(reactionType ?? null);
  };

  return (
    <div className={classNames("shrink-0 px-5 py-3", className)}>
      <Tabs.Root
        data-testid="reaction-filter-tabs"
        tabs={tabs}
        selectedValue={selectedReaction ?? "all"}
        onValueChange={handleValueChange}
      />
    </div>
  );
};
